// removed by extract-text-webpack-plugin
module.exports = {"space_title":"styles__space_title___151qz","space":"styles__space___1wcdK","container_buttons_export":"styles__container_buttons_export___1f2GK","display_center":"styles__display_center___2Q3aR","container_button_save":"styles__container_button_save___36KC6","inputClass":"styles__inputClass___FQ5xU","buttonSaveClass":"styles__buttonSaveClass___2drt-"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/ActionForm/styles.css
// module id = 980
// module chunks = 0